import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RepublicaMovilComponent} from './components/republica-movil/republica-movil.component';
import {RmSubheaderComponent} from './components/rm-subheader/rm-subheader.component';
import {RmIndexComponent} from './components/rm-index/rm-index.component';
import {RmNormalizaDireccionComponent} from './components/rm-normaliza-direccion/rm-normaliza-direccion.component';
import {RmCoberturaComponent} from './components/rm-cobertura/rm-cobertura.component';
import {RmRatesComponent} from './components/rm-rates/rm-rates.component';
import {RmMovilPackComponent} from './components/rm-movil-pack/rm-movil-pack.component';
/* import {NgbButtonsModule} from '@ng-bootstrap/ng-bootstrap'; */
import {RmUserDataComponent} from './components/rm-user-data/rm-user-data.component';
import {RmUserBankingDataComponent} from './components/rm-user-banking-data/rm-user-banking-data.component';
import {RmConfirmationComponent} from './components/rm-confirmation/rm-confirmation.component';
import {RmShoppingCartComponent} from './components/rm-shopping-cart/rm-shopping-cart.component';
import {RmLoaderComponent} from './components/rm-confirmation/rm-loader/rm-loader.component';
import {RmFinishedComponent} from './components/rm-finished/rm-finished.component';
import {RmListadoActivacionesComponent} from './components/rm-listado-activaciones/rm-listado-activaciones.component';
import {RmOrderDetailComponent} from './components/rm-order-detail/rm-order-detail.component';
import {SharedModule} from '../shared/shared.module';
import {RmModalSaveComponent} from './components/rm-modal-save/rm-modal-save.component';
import {RmGuardDraftGuard} from './services/rm-guard-draft.guard';
import {RmRateInfoComponent} from './components/rm-rate-info/rm-rate-info.component';
import {RmRateListComponent} from './components/rm-rate-list/rm-rate-list.component';
import {RepublicaMovilRouting} from './replublica-movil.routing';
import {AmenaModule} from '../amena/amena.module';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { RmModalReprocessComponent } from './components/rm-modal-reprocess/rm-modal-reprocess.component';
import { RmModalIccidComponent } from './components/rm-modal-iccid/rm-modal-iccid.component';


@NgModule({
    declarations: [
        RmIndexComponent,
        RmSubheaderComponent,
        RepublicaMovilComponent,
        RmNormalizaDireccionComponent,
        RmCoberturaComponent,
        RmRatesComponent,
        RmMovilPackComponent,
        RmUserDataComponent,
        RmUserBankingDataComponent,
        RmConfirmationComponent,
        RmShoppingCartComponent,
        RmLoaderComponent,
        RmFinishedComponent,
        RmListadoActivacionesComponent,
        RmOrderDetailComponent,
        RmModalSaveComponent,
        RmRateInfoComponent,
        RmRateListComponent,
        RmModalReprocessComponent,
        RmModalIccidComponent
    ],
    exports: [
        RmSubheaderComponent,
        RmShoppingCartComponent,
        MatSnackBarModule
    ],
    imports: [
        CommonModule,
        RepublicaMovilRouting,
/*         NgbButtonsModule, */
        SharedModule,
        AmenaModule
    ],
    providers: [
        RmGuardDraftGuard
    ]
})
export class RepublicaMovilModule {
}
